// OtpModal.jsx
import React from "react";

export default function OtpModal({
  otpModalOpen,
  setOtpModalOpen,
  user,
  otpSent,
  formData = {},
  setFormData,
  handleSendOtp, // <- use the navbar function
  otpInput,
  setOtpInput,
  otpError,
  setOtpError,
  verifyingOtp,
  handleVerifyOtp,
  resendTimer,
  setOtpSent,
  setResendTimer,
  shakeEmail,
  emailError,
  sendingOtp,
}) {
  if (!otpModalOpen || user) return null;

  return (
    <div className="fixed inset-0 bg-black/50  z-50 flex items-center justify-center animate-fadeIn  px-5">
      <div className="bg-white rounded-2xl w-full max-w-md shadow-xl overflow-hidden animate-fadeIn">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-lg font-semibold text-gray-900">Secure Login</h2>
          <button
            onClick={() => setOtpModalOpen(false)}
            className="text-gray-400 hover:text-red-600 text-lg"
          >
            ✕
          </button>
        </div>

        {/* Body */}
        <div className="p-6 space-y-4">
          <p className="text-sm text-gray-600">
            Please verify your email in order to login.
          </p>

          {!otpSent ? (
            <>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                placeholder="Enter your email address"
                className={`w-full border rounded-xl p-3 focus:ring-2 focus:ring-red-500 outline-none ${
                  shakeEmail ? "shake border-red-500" : ""
                }`}
              />
              {emailError && (
                <p className="text-red-600 text-sm">{emailError}</p>
              )}
              <button
                onClick={handleSendOtp}
                disabled={sendingOtp || otpSent} // disable while sending or already sent
                className={`w-full py-3 rounded-xl font-medium bg-red-600 hover:bg-red-700 text-white transition ${
                  sendingOtp || otpSent ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                {sendingOtp ? "Sending..." : "Send OTP"}
              </button>
            </>
          ) : (
            <>
              {/* OTP Sent Info */}
              <div className="bg-gray-50 rounded-xl p-3 text-sm text-gray-700 flex justify-between items-center">
                <span>
                  OTP sent to <b>{formData.email}</b>
                </span>
                <button
                  onClick={() => {
                    setOtpSent(false);
                    setOtpInput("");
                    setOtpError("");
                    setResendTimer(30);
                  }}
                  className="text-blue-600 text-xs underline hover:text-blue-800"
                >
                  Change
                </button>
              </div>

              {/* OTP Input */}
              <input
                type="text"
                placeholder="Enter 6-digit OTP"
                value={otpInput}
                onChange={(e) => setOtpInput(e.target.value)}
                className="w-full border rounded-xl p-3 text-center tracking-widest focus:ring-2 focus:ring-red-500 outline-none"
              />

              {otpError && <p className="text-red-600 text-sm">{otpError}</p>}

              <button
                onClick={handleVerifyOtp}
                disabled={verifyingOtp}
                className="w-full bg-red-600 text-white py-3 rounded-xl hover:bg-red-700 transition font-medium"
              >
                {verifyingOtp ? "Verifying..." : "Verify & Continue"}
              </button>
              <button
                onClick={handleSendOtp} // same function
                disabled={sendingOtp || resendTimer > 0}
                className={`w-full border border-red-600 text-red-600 py-2 rounded-xl hover:bg-red-50 transition
    ${sendingOtp || resendTimer > 0 ? "opacity-50 cursor-not-allowed" : ""}`}
              >
                {sendingOtp
                  ? "Sending..."
                  : resendTimer > 0
                    ? `Resend OTP in ${resendTimer}s`
                    : "Resend OTP"}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
